import React from 'react'; 
import '../../CSS/social_media.scss';
const SocialMedia = ({social})=> { 
  return (
    <div className="social">
        <ul className="list-group">
            <li className="list-group-item">
                <a href={social.facebook}>
                    <i  style={{color: '#fff'}} className="facebook fab fa-facebook-square"></i>
                </a>
            </li>
            <li className="list-group-item">
                <a href={social.linkedIn}><i  className="linkedin fab fa-linkedin"></i></a>
            </li>
            <li class="list-group-item">
                <a href={social.twitter}><i  className="twitter fab fa-twitter-square"></i></a>
            </li>
            <li className="list-group-item">
                <a href={social.gitHub}><i  className="github fab fa-github-square"></i></a>
            </li>
            <li className="list-group-item">
                <a href={social.instagram}><i  className="instagram fab fa-instagram"></i></a>
            </li>
        </ul>
    </div>

  );
}

export default SocialMedia; 